export var composeTwoDeviceData = function composeTwoDeviceData(firstDevice, secondDevice) {
  return firstDevice.map(function (item, index) {
    var _secondDevice$index;
    return {
      comparedDeviceData: (_secondDevice$index = secondDevice[index]) === null || _secondDevice$index === void 0 ? void 0 : _secondDevice$index.value,
      key: item.key,
      targetDeviceData: item === null || item === void 0 ? void 0 : item.value
    };
  });
};